// extracted by mini-css-extract-plugin
export default {"link":"AttachmentsBlock_link__YiwlN"};